import React, { useContext } from "react";
import { Copy } from "react-bootstrap-icons";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";

const ClipboardCell = ({ props }) => {
  const { setAlert } = useContext(ContextComponent);

  const {data, tableColumns} = props;

  const siteNameIndex = tableColumns?.indexOf("name");
  const isQuizColIndex = tableColumns?.indexOf("quiz");

  const siteName = data[siteNameIndex];
  const isQuiz = data[isQuizColIndex] || false;

  const url =
    (isQuiz
      ? Utils.APP_CONSTANTS.QUIZ_PAGE_URL
      : Utils.APP_CONSTANTS.SURVEY_PAGE_URL) + siteName;

  const copyToClipBoard = (urlToCopy) => {
    navigator.clipboard.writeText(urlToCopy);
    setAlert({
      show: true,
      message: "Link Copied Successfully!",
    });
  };

  const handleCopyToClipboard = (e) => {
    if (siteName) {
      if (!url) {
        setAlert({
          show: true,
            type: "warning",
          message: "No link available to copy!",
        });
      }
      copyToClipBoard(url);
    }
  };

  return (
    <>
      <span className="indi-clipboard-cell">
        <Copy size={16} onClick={handleCopyToClipboard} title={url} />
      </span>
    </>
  );
};

export default ClipboardCell;
